import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
// import { AngularFirestore } from 'angularfire2/firestore';
import { DataService } from '../providers/data.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  items: MenuItem[];
  available_apps: any;

  // constructor(private db: AngularFirestore, public dataService: DataService) { }
  constructor(public dataService: DataService) { }

  ngOnInit() {
    // this.db.collection('top_collections').valueChanges().subscribe(
    //   (result) => {
    //     let av_apps = [];
    //     for (let res of result) {
    //       let single_result = <any>res; // cast this to prevent ts error
    //       let app = {
    //         label: single_result.name,
    //         command: (event) => {
    //           this.setActive(single_result);
    //         }
    //       };
    //       av_apps.push(app);
    //     }
    //     this.available_apps = av_apps;
    //   }
    // );
    this.setNavItems();
  }

  setNavItems() {
    this.items = [
      // {
      //   label: 'Pagina\'s',
      //   icon: 'fa-file-text',
      //   routerLink: 'pages'
      // },
      // {
      //   label: 'Berichten',
      //   icon: 'fa-comment',
      //   routerLink: 'messages'
      // },
    ];
  }

  setActive(app: any) {
    this.dataService.active_app = app.name;
  }

}



// WEBPACK FOOTER //
// /Users/matthijs/projects/LC/lc-app-dashboard/src/app/navbar/navbar.component.ts